import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import cView from './cView';

export default class cUserList extends cView {

  $id_stgs = { //  子で上書き
    cLoadCnd:() => bf.q('[cm10b21k]="{}"'.f(
      global.c?.state.sgcd_pagePntKeys.cm20_key,
    )),
  };

  $cd_stss = { // 親を上書き
    sld_cm10ss: {},
  };

  $clp_loads = () => [ // 親を上書き
/*
    new Promise( _o_end1 => {
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next =>{ // sgcd_pagePntKeys の初期化
          _next.cm10_key = '';
          _next.cm10c310 = '';
        })
      }, ()=>{
        _o_end1();
      })
    }),
*/
    new Promise( _o_end1 => {
      //
      let _cnd = bf.q('[cm10b21k]="{}"'.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
      ));

      if (bf.f(global.c?.state.sgcd_schs.word)) {
        _cnd = bf.q('[cm10c310] LIKE "%{}%"'.f(global.c?.state.sgcd_schs.word));
      };
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm10', 
        n_dms: 3,
        state: 'sld_cm10ss', 
        cnd: _cnd,
        o_fnc: _d_cm10s => {
          return {
            pfx: '{}'.f(
              _d_cm10s.cm10c310,
            ),
            spf: '{}'.f(
              _d_cm10s.cm10i110,
            ),
          };
        },
        ld_sortss: [
          {fld: 'cm10cz10', dtn: 'desc', mode: 'nmb'},
          {fld: 'cm10cx10', dtn: 'asc', mode: 'nmb'},
          {fld: 'cm10cw10', dtn: 'asc', mode: 'str'},
        ],
      })
      .then(()=>{
        _o_end1();
      });
    }),
  ];

  render() {
    return ( //  子で上書き
      <ce.RootList
        b_logo={false}
        b_sch={true}
        onSchEnt={()=>{
          global.c.load();
        }}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iUserDtl',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: '',
          d_leftBtns: {},
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm10ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iUserDtl',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
}

//export default cUserList;
